var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-1'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-1'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2'
      )))]),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-1'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-1'
        )
      )}}),_c('br'),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-2'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-2'
        )
      )}}),_c('br'),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-3'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-3'
        )
      )}}),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-2-5'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-2-5'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-3'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-3'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-4'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-4'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-5'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-5'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.title-6'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsCernHelpCalculatingMethod.info-6'
        )
      )}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }